// extracted by mini-css-extract-plugin
module.exports = {"table":"src-com-components-resize-table-index__table","table_content":"src-com-components-resize-table-index__table_content","page":"src-com-components-resize-table-index__page"};